<script>
	import {API, get_semanas} from '../global.js'
	import {onMount} from 'svelte'
	import {createEventDispatcher} from 'svelte'
	const dispatch = createEventDispatcher()
	let hoy = new Date()
	let aYear = hoy.getFullYear()
	
	let loading=false
	let cant_semanas=''
	let productos = []
	let producto = 1
	let hotel = 1

	let tipos_semana = []
	let temporadas_arr = ['PUN','PLA','ORO','ROY','CLA']

	const close = () =>	dispatch('close')

	$: make_table = async () => {
		let semanas = get_semanas(aYear)
		await getTiposSemana(producto,hotel)
		return semanas
	}

	async function getTiposSemana(p,h){
		loading = true
		let rs = await fetch(`${API}/tipos-semana/${h}/${p}`)
		let ds = await rs.json()
		loading = false
		tipos_semana = ds.data || []
	}

	onMount( async() => {
		let rs = await fetch(`${API}/get-all/productos`)
		let ds = await rs.json()
		productos = ds.data || []
	})

</script>

<div class="offcanvas offcanvas-end show" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style="visibility: visible;">
  <div class="offcanvas-header">
    
		<div class="row">
			<div class="col">
				<button class="btn btn-dark btn-sm" on:click={()=>aYear--}>&lt;</button>
				<input class="text-center" size=4 bind:value={aYear}  on:change={make_table}/>
				<button class="btn btn-dark btn-sm" on:click={()=>aYear++}>&gt;</button>
				
			</div>
		</div>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" on:click="{close}"></button>
  </div>
  <div class="row ms-2 mb-2">
  	<div class="col">
	  	<label><input type=radio bind:group={hotel} name="hotel" value={1}>RDA</label>
			<label><input type=radio bind:group={hotel} name="hotel" value={2}>RDE</label>

			<select bind:value={producto}>
				{#each productos as prd, index}
					<option value="{prd.IdProducto}">{prd.Descripcion}</option>
				{/each}
			</select>
		</div>
	</div>
  <div class="offcanvas-body">


		{#await make_table()}
			<p>Loading...</p>
		{:then rs}
			<table class="table table-sm table-hover">
				<tbody style="font-size:0.6em;">
				{#each rs as item, index}
					<tr class="{temporadas_arr[tipos_semana[index]?(tipos_semana[index]).idtemporada : 0] || 'x'}">
						<td style="padding: 1px;" class="text-center {item.actual?'text-danger fw-bolder':''}">{item.semana}</td>
						<td style="padding: 1px;" class="text-center">{item.sa.substr(8)+'/'+item.sa.substr(5,2)}</td>
						<td style="padding: 1px;" class="text-center">{item.vi.substr(8)+'/'+item.vi.substr(5,2)}</td>
						<td style="padding: 1px;" class="text-center">{ temporadas_arr[tipos_semana[index]?(tipos_semana[index]).idtemporada : 0] || 'x'}</td>
					</tr>
				{/each}
				</tbody>
			</table>
		{/await}

  </div>
</div>

<style>
	.PLA { background-color:#e3e4e5; }
	.ORO { background-color:#efb810; }
	.ROY { background-color:#70ff8b; }
	.CLA { background-color:pink; }
	.x{}
</style>